import { useTranslation } from 'react-i18next'
import { BILLING_INTERVALS } from '@/lib/types/subscription'
import { cn } from '@/lib/utils'

type Props = {
  value: string
  onChange: (value: string) => void
  /** Best yearly saving across the plans on offer; 0 hides the hint. */
  savePercent: number
}

/** One Monthly/Yearly switch for every plan card (design 15c). */
export function BillingIntervalToggle({ value, onChange, savePercent }: Props) {
  const { t } = useTranslation('settings')
  const options = [
    { value: BILLING_INTERVALS.MONTHLY, label: t('subscription.interval.monthly') },
    { value: BILLING_INTERVALS.ANNUAL, label: t('subscription.interval.yearly') },
  ]

  return (
    <div
      role="radiogroup"
      aria-label={t('subscription.interval.label')}
      className="inline-flex items-center rounded-lg bg-secondary p-0.5"
    >
      {options.map((option) => {
        const selected = value === option.value
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(option.value)}
            className={cn(
              'inline-flex h-7 items-center gap-1.5 rounded-md px-3 text-[13px] transition-colors',
              selected
                ? 'bg-card font-semibold text-foreground shadow-xs'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {option.label}
            {option.value === BILLING_INTERVALS.ANNUAL && savePercent > 0 && (
              <span className="text-xs font-semibold text-emerald-600 dark:text-emerald-400">
                {t('subscription.interval.saveUpTo', { percent: savePercent })}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
